// Política de refetch dos detalhes: os terminais do WebSocket de status invalidam
// ["reports","details",id], então o poll por tempo é só fallback para quem está sem socket.

export const REPORT_DETAILS_FALLBACK_POLL_MS = 15_000;

export interface ReportDetailsPollInput {
    isPending: boolean;
    isSocketConnected: boolean;
    fallbackPollMs?: number;
}

export const resolveReportDetailsPollMs = ({
    isPending,
    isSocketConnected,
    fallbackPollMs = REPORT_DETAILS_FALLBACK_POLL_MS,
}: ReportDetailsPollInput): number | false => {
    if (!isPending) return false;
    if (isSocketConnected) return false;
    return fallbackPollMs;
};

export interface ReportDetailsSyncInput {
    hasPendingChanges: boolean;
    isSaving: boolean;
}

// Impede que um refetch sobrescreva uma edição de soft-delete não salva.
export const shouldSkipReportDataSync = ({
    hasPendingChanges,
    isSaving,
}: ReportDetailsSyncInput): boolean => hasPendingChanges || isSaving;
